import { routeList } from '@/router/helpers/routes'
/* Views */
import ThirdLevelMenu from '@/views/ThirdLevelMenu'
import BalancesAndMovements from '@/views/accounts/BalancesAndMovements'
import Details from '@/views/accounts/Details'
import Patrimony from '@/views/accounts/Patrimony'
import Extracts from '@/views/accounts/Extracts'
import Invoices from '@/views/accounts/Invoices'
import Visible from '@/views/accounts/Visible'
import UnderDevelopment from '@/views/UnderDevelopment'

export default [{
	path: routeList.ACCOUNTS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.ACCOUNTS_BALANCES_AND_MOVEMENTS_PATH,
	name: routeList.ACCOUNTS_BALANCES_AND_MOVEMENTS_NAME,
    props: true,
	component: BalancesAndMovements
}, {
	path: routeList.ACCOUNTS_PATRIMONY_PATH,
	name: routeList.ACCOUNTS_PATRIMONY_NAME,
	component: Patrimony
}, {
	path: routeList.ACCOUNTS_CASHFLOW_PATH,
	name: routeList.ACCOUNTS_CASHFLOW_NAME,
	component: UnderDevelopment
}, {
	path: routeList.ACCOUNTS_EXTRACTS_PATH,
	name: routeList.ACCOUNTS_EXTRACTS_NAME,
	component: Extracts
}, {
	path: routeList.ACCOUNTS_INVOICES_PATH,
	name: routeList.ACCOUNTS_INVOICES_NAME,
	component: Invoices
}, {
	path: routeList.ACCOUNTS_DETAILS_PATH,
	name: routeList.ACCOUNTS_DETAILS_NAME,
	component: Details
},
/* ***********************************************
*                       WALLET                   *
*********************************************** */
{
	path: routeList.ACCOUNTS_WALLET_PATH,
	name: routeList.ACCOUNTS_WALLET_NAME,
	props: true,
	component: ThirdLevelMenu
}, {
	path: routeList.ACCOUNTS_WALLET_CREATE_PATH,
	name: routeList.ACCOUNTS_WALLET_CREATE_NAME,
	component: UnderDevelopment
}, {
	path: routeList.ACCOUNTS_WALLET_REGIST_PATH,
	name: routeList.ACCOUNTS_WALLET_REGIST_NAME,
	component: UnderDevelopment
}, {
	path: routeList.ACCOUNTS_WALLET_LIMITS_PATH,
	name: routeList.ACCOUNTS_WALLET_LIMITS_NAME,
	component: UnderDevelopment
},
/* ******************* ************************ */
{
	path: routeList.ACCOUNTS_VISIBLE_PATH,
	name: routeList.ACCOUNTS_VISIBLE_NAME,
	component: Visible
}]
